export const buildList = [
    [
        {
            key: 9,
            value: "火灾自动报警系统",
        },
        {
            key: 12,
            value: "消防水源",
        },
        {
            key: 15,
            value: '消火栓系统'
        },
        {
            key: 18,
            value: '自动喷水灭火系统'
        },
        {
            key: 21,
            value: '水喷雾灭火系统'
        },
        {
            key: 24,
            value: '细水雾灭火系统'
        },

    ],
    [
        {
            key: 10,
            value: '泡沫灭火系统'
        },
        {
            key: 13,
            value: '固定消防炮灭火系统'
        },
        {
            key: 16,
            value: '自动跟踪定位射流灭火系统'
        },
        {
            key: 19,
            value: '气体灭火系统'
        },
        {
            key: 22,
            value: '干粉灭火系统'
        },
        {
            key: 25,
            value: '防烟排烟系统'
        }
    ],
    [
        {
            key: 11,
            value: '消防应急照明和疏散指示系统'
        },
        {
            key: 14,
            value: '防火分隔设施'
        },
        {
            key: 17,
            value: '电气火灾监控系统'
        },
        {
            key: 20,
            value: '可燃气体探测报警系统'
        },
        {
            key: 23,
            value: '消防设备电源监控系统'
        },
        {
            key: 26,
            value: '防火门监控系统'
        }
    ]
]

export const xfunit = [
    {
        value: 2,
        label: "青岛支队"
    },
    {
        value: 3,
        label: "崂山大队"
    },
    {
        value: 4,
        label: "市南大队"
    },
    {
        value: 5,
        label: "市北大队"
    },
    {
        value: 6,
        label: "李沧大队"
    },
    {
        value: 7,
        label: "城阳大队"
    }
]